import { apiGet } from '../../lib/api'
import { withAuth } from '../auth/token'

/** The records the warning compares: brokers and carriers, never agents (TRKC-99). */
export type SharedContactKind = 'Broker' | 'Carrier'

/** Another broker or carrier reached the way this one is, and how. */
export type SharedContactMatch = {
  kind: SharedContactKind
  id: string
  name: string
  /** False when we stood it down; it still counts, marked (Lino, 2026-10-07). */
  active: boolean
  /** `Address`, `Phone` and `Email`, in that order, as many as apply. */
  shared: string[]
}

export type SharedContactsView = {
  matches: SharedContactMatch[]
}

const BOOKS: Readonly<Record<SharedContactKind, string>> = {
  Broker: 'brokers',
  Carrier: 'carriers',
}

/** Computed at read on the server: nothing is stored, so a change on either side shows on the next read. */
export function getSharedContacts(kind: SharedContactKind, id: string): Promise<SharedContactsView> {
  return apiGet<SharedContactsView>(`/api/${BOOKS[kind]}/${id}/shared-contacts`, { headers: withAuth() })
}
